export default {
  label: "App Store",
  tabs: {
    softwareReview: {
      label: "Software Review",
      noSoftwareToReview: "No software pending review.",
      noSoftwareToReviewHelperText:
        "Pending software that needs to be reviewed will appear here, once it has been uploaded it through the terminal.",
    },
    myEdgeDevices: {
      label: "My Edge Devices",
      lastConnection: "Last Connection",
      updateStatus: "Update Status",
      sshSession: "SSH Session",
      appSetSubscriptions: "App Set Subscriptions ",
      activities: "Activities",
      appSetsToApps: {
        addButton: "Add Appsets",
        removeButton: " Remove Appsets",
      },
      myEdgeDeviceDetails: "My Edge DeviceDetails",
    },
    newReleases: {
      label: "Software Review",
      newVersion: "New Version",
      appSet: "New Releases",
      softwareToReview: "Apps Pending Review",
      deniedSoftware: "Denied Reviews",
      newAppset: "News App Set",
      apps: "Apps",
      app: "App",
      goBack: "Back to Software Review",
      appCategory: "App Category",
      appsOfSelectedSnapsets: {
        column: {
          version: "Version",
          revision: "Revision",
          releaseDate: "Release Date",
        },
      },
      removeApps: {
        message:
          "This app set is currently assigned to some of your devices. Removing selected app(s) will have a direct impact of those devices. Do you remove them anyway?",
        title: "Remove app(s)",
      },
      deviceList: "Device List",
      activities: "Activities",
      appCategories: "App categories",
      developer: "Developer",
      version: "Version",
      releaseDate: "Release Date",
      size: "Size[MB]",
      revision: "Revision",
      pushedSince: "Pushed since",
      firstRelease: "First release",
      currentlyInstalledOn: "Currently installed on",
    },

    softwarePackages: {
      label: "Software Packages",
      noSoftwareYet: (category: string) => `No ${category} software yet`,
      noSoftwareHelperText: "Software uploaded through the terminal will appear here.",
    },
    apps: {
      label: "Apps",
      addButton: "Add App",
      editAppDescription: "Edit App Description",
      shareToAllTenants: "Share to all tenants",
      sharedToAllTenants: "Shared to all tenants",
      notShared: "Not shared",
      sharedByMLPA: "Shared by MLPA",
      removeButton: "Remove App",
      developerLabel: "Developer",
      noAppsCreatedYet: "Add your first app",
      noAppsCreatedHelperText:
        "Apps must be uploaded via the terminal and then approved in the 'Software to Review' section.",
      appsOverview: {
        currentlyInstalledOn: "Currently installed on",
        noAppVersionsMessage: "No versions of this app have been released yet",
        columns: {
          versionEvaluation: "Version Evaluation",
          version: "Version",
          releaseDate: "Release Date",
          status: "Status",
          usage: "Usage",
          category: "Category",
          latestRevision: "Latest Revision",
          addToAppset: "App set assignment",
          detailPanel: {
            columns: { revision: "Revision", releaseDate: "Release Date", snapSets: "App sets" },
            dataList: {
              developerInfo: "Developer Info",
              developer: "Developer",
              releaseDate: "Release Date",
            },
          },
        },
      },
      usageOverview: {
        label: "Usage Overview",
        installedOn: "Installed on",
      },
      updatesOverview: {
        label: "Upadates Overview",
      },
      statusUpdate: {
        changeRatingTitle: "Change rating for version",
        changeRatingLabel: "Change rating",
        changeVersionEvaluation: "Change Version Evaluation",
      },
    },
    updatePropositions: {
      label: "Update Propositions",
    },
  },
};
